import React from "react";
import type { CSSProperties } from "react";

import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

interface VersionReviewDialogProps {
  isOpen: boolean;
  onClose: () => void;
  title: React.ReactNode;
  children: React.ReactNode;
  contentClassName?: string;
  shouldShowCloseButton?: boolean;
  hideHeader?: boolean;
  contentStyle?: CSSProperties;
}

export const VersionReviewDialog = ({
  isOpen,
  onClose,
  title,
  children,
  contentClassName = "max-h-[800px] max-w-[75vw]",
  shouldShowCloseButton = true,
  hideHeader = false,
  contentStyle,
}: VersionReviewDialogProps) => (
  <Dialog open={isOpen} onOpenChange={onClose}>
    <DialogContent
      className={contentClassName}
      shouldShowCloseButton={shouldShowCloseButton}
      style={contentStyle}
    >
      {!hideHeader && (
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
      )}
      {children}
    </DialogContent>
  </Dialog>
);
